import { z } from 'zod'

import { RequestOverrides } from '@/clients/BaseApiClient'
import { HTTPMethod } from '@/lib/requests/types'
import { WorldlineVerificationStatus } from '@/travelsuit/worldline'

import { getGGClient } from './GetGoingClient'

export async function log3DSEvent(
	redirectUrl: string,
	event: WorldlineVerificationStatus,
	overrides?: RequestOverrides,
) {
	return getGGClient().request(HTTPMethod.POST, 'three_d_secure/log', {
		requestSchema: z.object({
			redirect_url: z.string(),
			event: z.nativeEnum(WorldlineVerificationStatus),
		}),
		data: { redirect_url: redirectUrl, event },
		...overrides,
	})
}
